<template>
    <div class="modal-card card">
        <div class="card-header">
            <!-- Title -->
            <h4 class="card-header-title">
                {{ modalData.title || 'Config Updated' }}
                <span class="fa fa-circle-info text-muted" data-bs-toggle="tooltip" data-bs-placement="right"
                        :title="`Another user has modified the configuration(s) while you were editing. Please review the changes before saving.`">
                    </span>
                </h4>
            <!-- Close -->
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="card-body">
            <div>
                <p class="mb-1" v-if="details.updated_by">
                    <strong>Updated by:</strong>&nbsp;<span class="text-muted">{{
                        details.updated_by }}</span>
                </p>
                <p v-if="details.updated_at" class="mb-0">
                    <strong>Updated at:</strong>&nbsp;<span class="text-muted">{{
                        DateTimeFormat(details.updated_at) }}</span>
                </p>
            </div>
            <div class="row mb-1 mt-3">
                <div class="col-6 config">
                    Local Copy
                </div>
                <div class="col-6 config">
                    Remote Copy
                </div>
            </div>
            <div v-for="config in diff" :key="config.id">
                <p class="config text-primary fw-bold mb-2 mt-2">
                    {{ config.jobName || details.name || "" }}
                    <i v-if="config.jobName || details.name" class="fa fa-arrow-right-long pt-1 mx-2" style="font-size: 0.7rem;"></i>
                    {{ config.prev.relative_path }}
                </p>
                <Diff mode="split" :theme="$store.state.darkMode ? 'dark' : 'light'" language="plaintext" :prev="config.prev.content"
                    :current="config.current.content"/>
            </div>
        </div>
        <div class="card-footer d-flex justify-content-between align-items-center">
            <span class="text-danger" style="overflow-wrap: break-word;">
                {{ error }}
            </span>
            <div>
                <button class="btn btn-primary me-3" @click="onReload" :disabled="loading">
                    <div v-if="loading" class="spinner-border spinner-border-sm" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    Reload changes
                    <span class="fa fa-circle-info text-light ms-0" style="font-size: 0.85rem; margin-left: 5px;"
                        title="Reload changes from remote copy. Current changes will be lost."
                        data-bs-toggle="tooltip" data-bs-placement="top">
                    </span>
                </button>
                <button class="btn btn-primary" @click="onOverWrite" :disabled="loading">
                    <div v-if="loading" class="spinner-border spinner-border-sm" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    Overwrite Current Changes
                    <span class="fa fa-circle-info text-light ms-0" style="font-size: 0.85rem; margin-left: 5px;"
                        title="Overwrite current changes over remote copy."
                        data-bs-toggle="tooltip" data-bs-placement="top">
                    </span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { DateTimeFormat } from '../../utils/commonFunction';
export default {
    data() {
        return {
            error: "",
            loading: false
        }
    },
    props: {
        modalData: {
            type: Object,
        }
    },
    computed: {
        details() {
            return this.modalData.details ? this.modalData.details : ''
        },
        diff() {
            return this.modalData.diff ? this.modalData.diff : []
        }
    },
    name: "ConfigChanges",
    methods: {
        DateTimeFormat,
        async onReload() {
            this.loading = true;
            this.error = "";
            try {
                await this.modalData.onReload();
            } catch (error) {
                this.error = error.response?.data?.error || error.message;
                console.error("Error reloading config: ", error);
            } finally {
                this.loading = false;
            }
        },
        async onOverWrite() {
            this.loading = true;
            this.error = "";
            try {
                await this.modalData.onOverWrite();
            } catch (error) {
                this.error = error.response?.data?.error || error.message;
                console.error("Error overwriting config: ", error);
            } finally {
                this.loading = false;
            }
        }
    }
}
</script>

<style scoped>
.config {
    color: #2C7BE5;
    font-size: 0.9rem;
    margin-bottom: 0.5rem;
}
</style>